// @flow

import * as React from 'react'

import TelegramLogo from '../../images/Telegram_logo.svg'
// import MobileIcon from '../../images/Icon-Mobile.png'
// import iPhone from '../../images/coursetrackerapp-iphone-mockup.png'
import GifMockup from '../../images/mockup2-opt.gif'
// import iPhoneWebp from '../../images/coursetrackerapp-iphone-mockup.webp'

const Home = (): React.Element<'section'> => (
  <section className='background'>
    <div className='container container--center container--full-height container--wide'>
      <span className='tophat' role='img' aria-label='graduation hat'>🎓</span>
      <div className='home'>
        {/* <img className='home__icon' src={MobileIcon} alt='' /> */}
        <img className='home__icon' src={GifMockup} alt='' />
        <div className='home__phone'>
          <picture>
            {/* <source srcSet={iPhoneWebp} type='image/webp' /> */}
            <img alt='An iPhone' src={GifMockup} />
          </picture>
        </div>
        <div className='home__content'>
          <h1 className='home__content__title'>{`CourseTrackerApp`}</h1>
          <p className='home__content__sub-title'>
            {`👀 CourseTrackerApp is the first Telegram bot that tracks university courses, ⏳ 24h a day, ⚡️ incredibly fast.`}
            <br/><br/>
            {`🎓 Already supporting UIC, UIS, UIUC`} <strong>{`summer & fall`}</strong> {`terms.`}
            <br/><br/>
            {`🚀 The bot`} <strong>{`instantly`}</strong> {`notifies you once the seat becomes available, so you don't lose your seat never again.`}
          </p>
          <a
            href='https://t.me/CourseTrackerBot'
            className='btn btn--with-icon btn--with-icon--left'
            rel='noopener noreferrer'
            target='_blank'
            onClick={() => { window.firebase.analytics().logEvent('tg_btn_clicked'); }}
          >
            <img src={TelegramLogo} alt='' />
            {'Open in Telegram'}
          </a>
        </div>
      </div>
    </div>
  </section>
)

export default Home
